/**
 * @generated SignedSource<<ba515dac93fc754cf1d75345d36efe92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsContent_viewer" | "CreatorsSidebar_viewer">;
  readonly " $fragmentType": "CreatorsWrapper_viewer";
};
export type CreatorsWrapper_viewer$key = {
  readonly " $data"?: CreatorsWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatorsContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatorsSidebar_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "78bd880bd52ef05b787bf53271d52202";

export default node;
